import { dfApiUrl } from "../main";
export var isNullOrUndefined = function (obj) { return obj == null; }; // == to check for both null or undefined. Don't change to ===
export var isArray = function (obj) { return Array.isArray(obj); };
export var isObject = function (obj) { return Object.keys(obj).length > 0; };
export var safeStr = function (obj) { return obj || ''; };
export var personalizeKey = 'personalizeData';
export var GoogleApiKey = 'AIzaSyBQJ0eXrGr5Mo1VHQpsMRHIlwZIDHZguDw'; // Restricted key for Google Maps JS API and Geocoding API
// Safe localStorage access with fallback
var isLocalStorageAvailable = function () {
    try {
        var test = '__localStorage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    }
    catch (e) {
        return false;
    }
};
export var safeLocalStorageGetItem = function (key) {
    try {
        if (isLocalStorageAvailable()) {
            return localStorage.getItem(key);
        }
    }
    catch (e) {
        console.warn("Failed to get localStorage item: ".concat(key), e);
    }
    return null;
};
export var safeLocalStorageSetItem = function (key, value) {
    try {
        if (isLocalStorageAvailable()) {
            localStorage.setItem(key, value);
        }
    }
    catch (e) {
        console.warn("Failed to set localStorage item: ".concat(key), e);
    }
};
export var safeLocalStorageRemoveItem = function (key) {
    try {
        if (isLocalStorageAvailable()) {
            localStorage.removeItem(key);
        }
    }
    catch (e) {
        console.warn("Failed to remove localStorage item: ".concat(key), e);
    }
};
var dfStorage = sessionStorage;
export var path = { thankYou: '/thank-you' };
export function isNumber(number) {
    return number != null && typeof number === 'number';
}
export var dfKey = function () { return "df_".concat(dfApiUrl); };
/** US-536041  msclkid only on exact DF lander /df/home-loans (not home-loans-hau, etc.). */
export function isMsclkidCapturePath(pathname) {
    var p = (pathname || "").toLowerCase().replace(/\/+$/, "") || "/";
    return p === "/df/home-loans";
}
export function getDfFromStorage(flowId) {
    var id = flowId || dfKey();
    var data = (getJsonItem(dfKey()) && getJsonItem(dfKey())[id]) || {};
    return data && typeof data === "object" ? data : {};
}
export function formDataInStorage(flowId) {
    return getDfFromStorage(flowId)['formData'] || {};
}
export function fieldValueInStorage(fieldId, flowId) {
    return formDataInStorage(flowId)[fieldId] && formDataInStorage(flowId)[fieldId]['fieldValue'];
}
export function getJsonItem(key, storage) {
    if (storage === void 0) { storage = dfStorage; }
    try {
        var raw = storage.getItem(key);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
export function setJsonItem(key, json, storage) {
    if (storage === void 0) { storage = dfStorage; }
    try {
        storage.setItem(key, JSON.stringify(json));
    }
    catch (ex) {
        console.log('utils.getJsonItem exception setting to key:', key, 'ex:', ex);
    }
}
export function saveToDfStorage(key, value) {
    var df = getJsonItem(dfKey()) || {};
    df[key] = value;
    setJsonItem(dfKey(), df);
}
export function readDfStorage(key) {
    var df = getJsonItem(dfKey());
    return df && df[key];
}
export function removeFromStorage(key) {
    var df = getJsonItem(dfKey());
    if (df && df[key]) {
        delete df[key];
        setJsonItem(dfKey(), df);
    }
}
export function removeFromFormData(key) {
    var sessionDf = getDfFromStorage();
    if (sessionDf && sessionDf.formData && key in sessionDf.formData) {
        delete sessionDf.formData[key];
        saveToDfStorage(dfKey(), sessionDf);
    }
}
export function removeDynamicFormData() {
    dfStorage.removeItem(dfKey());
}
export var parse = function (text) {
    return safeStr(text).replace('{%FirstName}', fieldValueInStorage('FirstName') || '');
};
export function formatAsCurrency(num) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    });
    return formatter.format(num);
}
export function parseCurrency(num) {
    var _a;
    return (_a = num === null || num === void 0 ? void 0 : num.toString()) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9.]/g, '');
}
export var isEmptyObject = function (obj) { return Object.keys(obj).length === 0; };
export function getValueBySuffix(obj, suffix) {
    for (var key in obj) {
        if (key.endsWith(suffix)) {
            return obj[key].fieldValue;
        }
    }
    return null;
}
export function getValueByText(text, opts) {
    var found = opts.find(function (o) { return o.text === text; });
    return found === null || found === void 0 ? void 0 : found.value;
}
export function updateSessionFromUrlParams() {
    var params = new URLSearchParams(window.location.search);
    if (!params.toString())
        return;
    for (var _i = 0, _a = Array.from(params.entries()); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var k = key.toLowerCase();
        var v = value.toString().toLowerCase().replace(/\//g, '');
        sessionStorage.setItem(k, v);
        // console.log(`Set sessionStorage ${k} = ${v}`);
    }
}
export function readUrlParam(name) {
    var lookup = window.urlParamLookup;
    if (!lookup)
        return undefined;
    var target = name.toLowerCase();
    for (var _i = 0, _a = Object.keys(lookup); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key.toLowerCase() === target && lookup[key])
            return lookup[key];
    }
    return undefined;
}
export function isGuid(value) {
    if (!value)
        return false;
    var trimmed = value.trim();
    if (/^0{8}-0{4}-0{4}-0{4}-0{12}$/i.test(trimmed))
        return false;
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(trimmed);
}
